<template>
    <div class="requests__list_table">
        <div class="columns is-block-mobile columns--margin-1-mobile is-variable">
            <div class="column"></div>
            <div class="column is-narrow">
                <component-button
                    :name="'requests-list-table-item-actions-approve'"
                    :theme="'primary'"
                    :disabled="!requestsLength || requestPending"
                    :animate-loading="true"
                    :animate-loading-event-name="'approve-all'"
                    @click="performApproveAllEnrolments"
                >Approve all shown
                </component-button>
            </div>
            <div class="column is-narrow">
                <component-button
                    :name="'requests-list-table-item-actions-reject'"
                    :theme="'default'"
                    :disabled="!requestsLength || requestPending"
                    :animate-loading="true"
                    :animate-loading-event-name="'reject-all'"
                    @click="performRejectAllEnrolments"
                >Reject all shown
                </component-button>
            </div>
        </div>
        <component-separator></component-separator>
        <component-table
            :labels="[
                {
                    key: 'learnerName',
                    title: 'Learner name',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'courseName',
                    title: 'Course name',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'createdAt',
                    title: 'Request date',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'enrolmentStatus',
                    title: 'Request status',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'createdBy',
                    title: 'Actioned by',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'actions',
                    title: '',
                    type: '',
                    sortable: false
                }
            ]"
            :items="items"
            :disabled="requestPending"
            :component-table-item="RequestsListTableItem"
            :sort-queryable="sortQueryable"
            @emit-sort="handleSort"
            @emit-perform-get-items="emitPerformGetItems"
        />
    </div>
</template>

<script>
import RequestsListTableItem from '@/components/ebs/requests/list/RequestsListTableItem'
import ComponentTable from '@/components/default/shared/ComponentTable'
import ComponentSeparator from '@/components/default/shared/ComponentSeparator'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  components: {
    ComponentButton,
    ComponentSeparator,
    ComponentTable
  },
  name: 'requests-list-table',
  data () {
    return {
      RequestsListTableItem,
      requestPending: false
    }
  },
  props: {
    items: {
      type: [Array, Object]
    },
    sortQueryable: {
      type: Boolean
    }
  },
  computed: {
    requestsLength () {
      return this.$store.getters.getEbsRequestsTotalResults
    }
  },
  methods: {
    handleSort (data) {
      this.$emit('emit-sort', data)
    },
    performApproveAllEnrolments () {
      this.requestPending = true
      this.$store.dispatch('ebsRequestsBulkApprove').finally(() => {
        this.requestPending = false
        this.$eventBus.$emit('stop-approve-all')
        this.emitPerformGetItems()
      })
    },
    performRejectAllEnrolments () {
      this.requestPending = true
      this.$store.dispatch('ebsRequestsBulkReject').finally(() => {
        this.requestPending = false
        this.$eventBus.$emit('stop-reject-all')
        this.emitPerformGetItems()
      })
    },
    emitPerformGetItems (data) {
      this.$emit('emit-perform-get-items')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/requests/requestslisttable";
</style>
